import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetSysErrorCodeSaga() {
    yield put(appActions.SYSERRORCODE_RESET_SUCCESS());
}

function* watchSysErrorCodeUpdateRequest() {
    yield takeLatest(
        appActions.SYSERRORCODE_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/error-code/update',
                appActions.SYSERRORCODE_UPDATE_SUCCESS,
                appActions.SYSERRORCODE_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchSysErrorCodeCreateRequest() {
    yield takeLatest(
        appActions.SYSERRORCODE_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/error-code/save',
                appActions.SYSERRORCODE_CREATE_SUCCESS,
                appActions.SYSERRORCODE_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchSysErrorCodeDeleteRequest() {
    yield takeLatest(
        appActions.SYSERRORCODE_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/system/error-code/delete',
                appActions.SYSERRORCODE_DELETE_SUCCESS,
                appActions.SYSERRORCODE_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchSysErrorCodeGetAllRequest() {
    yield takeLatest(
        appActions.SYSERRORCODE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/system/error-code/filter',
                appActions.SYSERRORCODE_GET_ALL_SUCCESS,
                appActions.SYSERRORCODE_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* SysErrorCodeWatcher() {
    yield* watchSysErrorCodeUpdateRequest();
    yield* watchSysErrorCodeCreateRequest();
    yield* watchSysErrorCodeGetAllRequest();
    yield* watchSysErrorCodeDeleteRequest();
    yield takeLatest(appActions.SYSERRORCODE_RESET_REQUEST.type, resetSysErrorCodeSaga);
    // Add other watchers here
}
